<template>
  <div class="content-calendar-new-page">
    <!--<StepsProgressBar class="content-calendar-new-page__progressbar" :currentStep="activeStep" :numberOfSteps="totalNumberOfSteps" :fontSize="19" color="teal" />-->

    <StepUploadContent
      class="content-calendar-new-page__step-container"
      :customerId="customerId"
      :galleryGroups="allPhotoGalleryGroupsSorted"
      @update:galleryGroups="updatedGalleryGroupsList => (allPhotoGalleryGroups = updatedGalleryGroupsList)"
      :isLoading="isLoadingPhotoGalleryGroups"
      @proceed="async () => await router.push({ name: 'CalendarPosts', params: { customerId } })"
    />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import ContentCalendarRepo from "@repos/ContentCalendarRepo";
import { getGlobalRemoteLogger } from "@helpers/RemoteLogger";
import { MetricSender } from "@/helpers/MetricSender";
import AdminContext from "@logic/AdminContext";

// Components
// steps
import StepUploadContent from "./steps/StepUploadContent.vue";

// Types
import { PhotoGalleryCustomerData } from "@contracts/photosPageData";

// Router
const route = useRoute();
const router = useRouter();
const remoteLogger = getGlobalRemoteLogger();

defineOptions({
  name: "CalendarUploadContent",
});

// Normalize route params ------------------------------------------------------
const customerId = computed<string>(() => (Array.isArray(route.params.customerId) ? route.params.customerId[0] : (route.params.customerId as string)));

// Load or generate photo galleries ===========================================
const allPhotoGalleryGroups = ref<Array<PhotoGalleryCustomerData>>([]);
const allPhotoGalleryGroupsSorted = computed<Array<PhotoGalleryCustomerData>>(() => {
  return (
    [...allPhotoGalleryGroups.value]
      // removed: sorting by createdSource is not needed anymore
      // sort from newest to oldest
      .sort((a, b) => b.createdOn.localeCompare(a.createdOn))
  );
});

const isLoadingPhotoGalleryGroups = ref<boolean>(false);

onMounted(async () => {
  await AdminContext.setOrgInContextFromCustomerId(customerId.value);
  isLoadingPhotoGalleryGroups.value = true;
  // Load the upload groups (they get created on setup now)
  allPhotoGalleryGroups.value = await ContentCalendarRepo.loadUploadGroups(customerId.value);

  isLoadingPhotoGalleryGroups.value = false;

  MetricSender.sendMetric("Cust-Calendar-Uploads-PageView", { customerId: customerId.value });
});
</script>

<style scoped lang="scss">
@import "@/scss/screen-size-ranges.scss";

// Content calendar new page ==================================================
.content-calendar-new-page {
  width: $desktop-wide-right-col-width;
  margin: 0 auto;

  &__progressbar {
    margin-bottom: 40px;
  }
}
// desktop wide -----------------------
@media (min-width: $desktop-wide-min-width) {
}
// desktop ----------------------------
@media (min-width: $desktop-min-width) and (max-width: $desktop-max-width) {
  .content-calendar-new-page {
    width: $desktop-right-col-width;
  }
}
// laptop -----------------------------
@media (min-width: $laptop-min-width) and (max-width: $laptop-max-width) {
  .content-calendar-new-page {
    width: $laptop-right-col-width;
  }
}
// tablet large -----------------------
@media (min-width: $tablet-large-min-width) and (max-width: $tablet-large-max-width) {
  .content-calendar-new-page {
    width: $tablet-large-content-width;
  }
}
// tablet -----------------------------
@media (min-width: $tablet-min-width) and (max-width: $tablet-max-width) {
  .content-calendar-new-page {
    width: $tablet-content-width;
  }
}
// mobile -----------------------------
@media (max-width: $mobile-max-width) {
  .content-calendar-new-page {
    width: $mobile-content-width;
  }
}
</style>
